import { useEffect } from 'react';
import { SimulationConfig } from '@/types';

export const useKeyboardControls = (
  config: SimulationConfig,
  isPlaying: boolean,
  setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>,
  initSimulation: (resetRounds?: boolean) => void,
  isRotationStoppedRef: React.MutableRefObject<boolean>,
  onThrow: () => void,
  onReset?: () => void
) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
      if (e.code === 'Space') { 
        e.preventDefault(); 
        if (isPlaying) initSimulation(true);
        else setIsPlaying(true);
      }
      else if (e.code === 'Backspace') {
        e.preventDefault();
        setIsPlaying(false);
      }
      else if (e.code === 'KeyS' && config.mode === 'ESCAPE') {
          isRotationStoppedRef.current = !isRotationStoppedRef.current;
      }
      else if (e.code === 'KeyR' && e.shiftKey && e.altKey) {
        e.preventDefault();
        if (window.confirm("Reset all settings to factory defaults?")) {
            onReset?.();
        }
      }
      else if (e.code === 'KeyB' && config.mode === 'SPACE_SPIRAL') {
          onThrow();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [initSimulation, isPlaying, config.mode, onThrow, onReset]);
};
